import { createAPI } from '@common'
export default {
  // 部门用户列表
  getUserByOrg: (config, vconfig) => createAPI('customEncryptApiName-1/0w20vtfst0czPsh', 'GET', config, vconfig),
  // /e5/actions/enabled?params={"docTypeCode":"STAT",name:"赋分统计"}
  getActionsEnabled: (config, vconfig) => createAPI('customEncryptApiName-1/0f60bdujpot0fobcmfe', 'GET', config, vconfig)
}
